import Vue from 'vue';
import Vuex from 'vuex';
import ReportPageModule from './modules/ReportPage/index';
// import Loading from 'quasar/src/plugins/Loading.js';;
// import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 彈跳視窗是否出現
    alert: false,
    // 彈跳視窗的字
    alertWord: '',
    token: process.env.VUE_APP_ANALYZE_API_KEY
  },
  getters: {},
  mutations: {
    // 設定彈跳視窗的狀態
    CHANGE_ALERT_STATUS(state, data) {
      state.alert = data;
    },
    // 設定彈跳視窗的文字
    CHANGE_ALERT_WORD(state, data) {
      state.alertWord = data;
    }
  },
  actions: {},
  modules: { ReportPageModule }
});
